import { useCallback, useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setModal } from "../../../Store/features/stateSlice";
import { setProfile } from "../../../Store/features/clientProfileSlice";

import { makeGetProfileRequest } from "API/Profile";
import HeaderMenu from "./HeaderMenu";
import Footer from "../../../Components/Footer";
import Modal from "../../../Containers/Pages/Modal";

import "./AuthenticatedPage.css";
import Dashboard from "./Dashboard";
import CreateGames from "./CreateGames";
import { setPuzzleType } from "Store/features/public/publicPuzzleSlice";
import { REQUESTS } from "Util/constants";
import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";
import CreatedGameConfirmation from "./CreatedGameConfirmation";
import LoadingScreen from "../Modal/modals/LoadingScreen";
import VerifyEmailCta from "Containers/Pages/Authenticated/VerifyEmailCta";

const AUTHED_PAGE_STATES = {
  DASHBOARD: "dashboard",
  CREATE_GAME: "create_game",
  CREATE_GAME_INPUT_TEXT: "create_game_input_text",
  EDIT_GAME: "edit_game",
  CREATED_GAME_CONFIRMATION: "created_game_confirmation",
};

const AuthenticatedPage = (props) => {
  const { authToken } = props;
  const dispatch = useDispatch();
  const activeModal = useSelector((state) => state.stateSlice.activeModal);
  const recentlyCreatedPuzzle = useSelector(state=>state.stateSlice.recentlyCreatedPuzzle);
  useEffect(() => {
    console.log('recentlyCreatedPuzzle')
    console.log({recentlyCreatedPuzzle})
  }, [recentlyCreatedPuzzle])
  const createdPuzzleRequestStatus = useSelector(
    (state) => state.stateSlice.requests[REQUESTS.SAVE_PUZZLE]
  );
  const puzzles = useSelector((state) => state.clientProfileSlice.puzzles);
  const profile = useSelector((state) => state.clientProfileSlice.profile);

  const { puzzle, puzzleType } = useSelector((state) => state.puzzleSlice);
  const getProfile = useCallback(async () => {
    const profile = await makeGetProfileRequest(dispatch, authToken);
    console.log('profile', profile)
    dispatch(setProfile(profile));
  }, [authToken, dispatch, setProfile]);

  useEffect(() => {
    if (createdPuzzleRequestStatus === "success") {
      getProfile();
      setAuthedPageState(AUTHED_PAGE_STATES.CREATED_GAME_CONFIRMATION);
      // Clear Selected Puzzle
      dispatch(setPuzzleAndPuzzleType({}));
    }
  }, [createdPuzzleRequestStatus]);

  useEffect(() => {
    getProfile();
  }, []);

  const [authedPageState, setAuthedPageState] = useState(
    AUTHED_PAGE_STATES.DASHBOARD
  );

  const handleExitCreateGames = useCallback(() => {
    setAuthedPageState(AUTHED_PAGE_STATES.DASHBOARD);
    dispatch(setPuzzleType());
  }, [setAuthedPageState]);

  const handleClickHamburgerMenu = useCallback(() => {
    dispatch(setModal("HAMBURGER_MENU"));
  }, [dispatch, setModal]);

  const AuthedPageContent = useMemo(() => {
    if (!profile?.id) return () => <LoadingScreen />;
    if (!profile?.isEmailVerified) return () => <VerifyEmailCta />
    if (authedPageState === AUTHED_PAGE_STATES.CREATED_GAME_CONFIRMATION) {
      return () => (
        <CreatedGameConfirmation
          createdPuzzle={recentlyCreatedPuzzle}
          onDismissConfirmation={() => {
            setAuthedPageState(AUTHED_PAGE_STATES.DASHBOARD);
          }}
        />
      );
    }
    if (
      authedPageState === AUTHED_PAGE_STATES.CREATE_GAME ||
      authedPageState === AUTHED_PAGE_STATES.EDIT_GAME ||
      puzzleType
    )
      return () => (
        <CreateGames
          onClickExitCreateGames={handleExitCreateGames}
          puzzleType={puzzleType}
        />
      );
    return () => (
      <Dashboard
        dashboadPuzzles={puzzles}
        onClickCreateGame={() => {
          setAuthedPageState(AUTHED_PAGE_STATES.CREATE_GAME);
        }}
      />
    );
  }, [profile, authedPageState, setAuthedPageState, puzzles, puzzleType, recentlyCreatedPuzzle]);
  return (
    <div className="authenticated-page-container">
      <HeaderMenu onClickHamburgerMenu={handleClickHamburgerMenu} />
      <AuthedPageContent />
      <Footer />
      {activeModal && (
        <Modal isPublic={false} shouldShowModal={Boolean(activeModal)} modal={activeModal} />
      )}
    </div>
  );
};

export default AuthenticatedPage;
